import React from 'react';
import IconType from './iconType';

function CaretDown({ color = '#7F38E9', height = 25, width = 25, ...rest }: IconType) {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5994 9.75265C17.9363 10.0895 17.9363 10.6357 17.5994 10.9725L12.9988 15.573C12.662 15.9099 12.1159 15.9099 11.779 15.573L7.17843 10.9725C6.84157 10.6357 6.84157 10.0895 7.17843 9.75265C7.51529 9.41578 8.06147 9.41578 8.39833 9.75265L12.3889 13.7432L16.3796 9.75265C16.7164 9.41578 17.2625 9.41578 17.5994 9.75265Z"
        fill={color}
      />
    </svg>
  );
}

export default CaretDown;
